import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="footer-container">
      {/* Left side text */}
      <div className="footer-left-text">
        © All Rights Reserved 2025,
     
        Powered by Emo Matrix Services Pvt. Ltd
      </div>
      {/* Right side buttons */}
      <div className="footer-right-buttons">
        <button
          className="footer-button"
          onClick={() => {
            navigate("/terms");
          }}
        >
          Terms & Conditions
        </button>
        <span className="footer-separator">|</span>
        <button
          className="footer-button"
          onClick={() => {
            navigate("/privacy");
          }}
        >
          Privacy Policy
        </button>
        <span className="footer-separator">|</span>
        <button
          className="footer-button"
          onClick={() => {
            navigate("/refund");
          }}
        >
          Refund Policy
        </button>
        <span className="footer-separator">|</span>
        <button
          className="footer-button"
          onClick={() => {
            navigate("/about");
          }}
        >
          About Us
        </button>
        <span className="footer-separator">|</span>
        <button
          className="footer-button"
          onClick={() => {
            navigate("/contact");
          }}
        >
          Contact Us
        </button>
        <span className="footer-separator">|</span>
        <button
          className="footer-button"
          onClick={() => {
            navigate("/price");
          }}
        >
          Pricing Details
        </button>

        <span className="footer-separator">|</span>
        <button
          className="footer-button"
          onClick={() => {
            navigate("/signup");
          }}
        >
          Psychologist SignUp
        </button>
      </div>
    </div>
  );
};

export default Footer;
